import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivity } from 'lib/selectors/getLatestActivity';

const getLatestActivityEndAt = createSelector(
  [getLatestActivity],
  (latestActivity) => {
    return _get(latestActivity, 'end');
  }
);

export { getLatestActivityEndAt };
